import { Api } from "../helpers";

export const apFinalizedService = {
  getById,
  getList,
  getPdf,
  createCustomerUrl,
  getBySlug,
  authClosure,
  submitStars,
  getStats,
};

// get the ap by his id
function getById(id) {
  return Api()
    .get("/accept-protocol/" + id + "/finalized")
    .then((response) => {
      return response.data.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// get the list of all finalized accept protocol's
// {state: 'all}
function getList(options) {
  const query = new URLSearchParams(options).toString();

  return (
    Api()
      //.get("/accept-protocols/finalized" + query, { options })
      .get("/accept-protocols/finalized?" + query)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        return Promise.reject(err);
      })
  );
}

// get the list of all finalized accept protocol's for stats
// {state: 'all}
function getStats(options) {
  return Api()
    .get("/accept-protocols/stats?", { params: options })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// get the pdf
function getPdf(options) {
  // dif config for file downloading
  const config = {
    headers: { Accept: "application/pdf", "Content-Type": "application/json" },
    responseType: "arraybuffer",
  };

  return Api()
    .get("/closure/" + options.slug + "/pdf", config)
    .then((response) => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([response.data], { type: "application/pdf" });

      // https://stackoverflow.com/questions/50736657/vue-laravel-how-to-properly-download-a-pdf-file
      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (
        window.navigator &&
        window.navigator.msSaveOrOpenBlob &&
        window.navigator.userAgent.indexOf("Edge") == -1
      ) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.setAttribute("download", "work-report.pdf");
      link.dispatchEvent(new MouseEvent("click"));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 200);
      return response.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// get the pdf
function createCustomerUrl(options) {
  return Api()
    .get("/accept-protocol/" + options.id + "/create-customer-url", {
      params: {
        attachments: options.attachments,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// get the ap by his slug (url sent to customer)
function getBySlug(options) {
  return Api()
    .post("/closure/" + options.slug, options)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// customer passed secret (got by email), auth it, if ok return
function authClosure(options) {
  return Api()
    .post("/closure/" + options.slug + "/auth", options)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// add closure to meta (apFInalized can have many meta)
function submitStars(options) {
  return Api()
    .put("/closure/" + options.slug, options.data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}
